<template>
    <div>
        <Nav/>
        <div class="pageWD">
            <div v-if="!isNone">
                <div class="livingWrap" v-if="firstData">
                    <div class="livingTitle" v-if='firstState == 1'>
                        <img src="../../assets/images/zz_zhibo.png" alt="" class="titleImg">
                    </div>
                    <div class="livingTitle" v-else>
                        <img src="../../assets/images/yy_zhibo.png" alt="" class="titleImg">
                    </div>
                    <div class="livingInfo">
                        <div class="livingImg">
                            <img :src="firstLogo" alt="">
                        </div>
                        <div class="livingText">
                            <h3 class="livingName">
                                <img src="../../assets/images/shipin.png" alt="">
                                <span>{{firstName}}</span>
                            </h3>
                            <div class="livingState" v-if="firstState == 0">
                                <img src="../../assets/images/weikaishi.png" alt="">
                                <span style="color:#F48549">未开始</span>
                            </div>
                            <div class="livingState" v-else>
                                <img src="../../assets/images/zhibo.png" alt="">
                                <span>正在直播中</span>
                            </div>
                            <ul class="livingTeacher">
                                <li>
                                    <span>主讲老师：{{firstTeacher}}</span>
                                </li>
                                <li>
                                    <span>开播时间：{{$conFun.parseData(firstTime)}}</span>
                                </li>
                            </ul>
                            <!-- <a :href='"/Live?liId="+firstId' class="toWatch"></a> -->
                            <router-link class="toWatch" :to="{path:'Live',query:{liId:firstId}}">{{firstState == 0 ? "即将开始" : "观看直播"}}</router-link>
                        </div>
                    </div>
                </div>
                <!-- 全部直播 -->
                <div class="videoWrap">
                    <h3 class="totalVideo">
                        <img src="../../assets/images/quanbuzhibo.png" alt="">
                    </h3>
                    <ul class="videoList">
                        <li 
                            class="videoItem" 
                            v-for='(item,index) in list' 
                            :key="item.liId" 
                            @mouseover="overActive(index,item.type,item.liId)" 
                            @mouseleave="leaveAction(index,item.type,item.liId)"
                            @click="toDetail(item.liId,item.type,item.liState)"
                        >
                            <div class="videoPostImg">
                                <div class="stateWrap" v-show='isBackSee == item.liId ? true : false'>
                                    <div class="videoMask"></div>
                                    <div class="hoverState">
                                        <em v-if="item.liState == 2" class="iconfont icon-a-6_huifang w-color" ></em>
                                        <em v-else class="iconfont icon-a-11_zhibozhong w-color"></em>
                                        <span>{{item.liState == 2 ? "观看回放" : item.liState == 1 ? "观看直播" : item.liState == 0 ? "即将开始" : ""}}</span>
                                    </div>
                                </div>
                                <img :src="item.liLogo" alt="">
                            </div>
                            <div class="videoInfo">
                                <div class="videoName">
                                    <img :src="item.type == 2 ? audioIcon:videoIcon" alt="">
                                    <span class="videoTitleName" :class="mouseOverActive == item.liId ? 'mouseOverClass':''">{{item.liName}}</span>
                                </div>
                                <div class="videoTeacher">主讲老师：{{item.speakerName}}</div>
                                <div class="videoTime">
                                    <span class="videoState" v-if="item.liState == 0">
                                        <span class="iconfont icon-a-7_weikaishi o-color"></span>
                                        <em class="o-color">未开始</em>
                                    </span>
                                    <span class="videoState" v-else-if="item.liState == 1">
                                        <span class="iconfont icon-a-11_zhibozhong g-color"></span>
                                        <em class="g-color">直播中</em>
                                    </span>
                                    <span class="videoState" v-else>
                                        <span class="iconfont icon-a-6_huifang h-color"></span>
                                        <em class="h-color">已结束</em>
                                    </span>
                                    <em class="livingTime">开播时间：{{$conFun.parseData(item.liStartTime)}}</em>
                                </div>
                            </div>
                            <router-link 
                                class="toPlay" 
                                :class="mouseOverActive == item.liId ? 'btnActive':''"
                                :to="{path:item.liState == 2 ? 'Lookback' : 'Live',query:{liId:item.liId}}"
                                v-if="item.type!=2"
                            >{{item.liState == 2 ? "观看回放" : item.liState == 1 ? "观看直播" : item.liState == 0 ? "即将开始" : ""}}</router-link>
                            <div 
                                class="toPlay" 
                                @click="tipShow"
                                :class="mouseOverActive == item.liId ? 'btnActive':''"
                                v-else
                            >{{item.liState == 2 ? "观看回放" : item.liState == 1 ? "观看直播" : item.liState == 0 ? "即将开始" : ""}}</div>
                            
                        </li>
                        
                    </ul>
                    <div class="dixian" v-if='isload'>我是有底线的</div>
                    
                </div>
            </div>
           
            <!-- 没有直播列表 -->
            <div  v-if="isNone" class="pageWD shadowBox mT20 minHeight" >
                  <div class="pheader flex flex-sb think">
                        <img src="../../assets/images/quanbuzhibo.png"  style="width: 145px; height: 58px;">
                    </div>                 
                   
                    <div class="emptyList">
                     <img src="../../assets/images/zanwuneirong.png" alt="">
                    </div>
                   
               
            </div>
        </div>
        <AudioTip :isTip="isTip" @hideMe="tip"/>
    </div>
    
    
</template>

<script>
    import Cookies from "js-cookie";
    import { getLives } from '@/api/api'
    import Nav from '../../components/Nav'
    import AudioTip from '../../components/AudioTip.vue';
    // import BreadCrumb from '../../components/BreadCrumb.vue'
    export default {
        name:'Listlist',
        components:{Nav,AudioTip},
        data(){
            return{
                isNone:false,
                isTip: false, //音频直播弹窗
                isload:false,
                list: [],
                page: 1,
                pageSize: 10,
                memberId:Cookies.get('qslmemberId'),
                coid:Cookies.get('qslCOID'),
                isBackSee:false,
                mouseOverActive:'',  //鼠标移入改变样式
                videoIcon:require('../../assets/images/shipin_n.png'),
                audioIcon:require('../../assets/images/yinpin_n.png'),
                firstData:false,  //第一条数据是否为未开始或直播中
                firstName:'',   //第一调数据的名字
                firstTeacher:'', //第一条数据主讲老师
                firstTime:'',    //第一条数据的开播时间
                firstState:'',    //第一条1正在直播，0未开始
                firstLogo:'',    //第一条视频封面
                firstId:''
            }
        },
        computed: {
            
        },  
        methods:{
            // li跳转详情页
            toDetail(id,type,state){
                if( type == 3 && state == 2 ){   //视频，已结束
                    this.$router.push({path:'Lookback',query:{liId:id}});
                }else if( type == 3 && (state == 0 || state == 1) ){  //视频，未开始或直播中
                    this.$router.push({path:'Live',query:{liId:id}});
                }else if( type == 2 ){  //音频，未开始
                    this.isTip = true;
                };
                
            },
            tipShow(){
                this.isTip = true;
            },
            tip(){
                this.isTip = false;
            },
            handleClose(done) {
                done();
            },
            // 获取直播列表
            getList() {

                let videoData = {
                    memberId: this.memberId,
                    coId: this.coid,
                    state: 4,
                    pageIndex: this.page,
                    pageSize: this.pageSize
                };
                var that = this;
                getLives(videoData)
                    .then(res => {
                        if( res.code == 200 ){
                            // console.log(res);
                            let realLength = res.body.result.length;
                            let listData = res.body.result;
                            if( listData.length != 0 ){
                                for(var i=0; i<listData.length; i++){
                                    if( !this.firstData ){
                                        if( (listData[i].liState == 0 || listData[i].liState == 1) && listData[i].type == 3){
                                            this.firstData = true;
                                            this.firstName = listData[i].liName;
                                            this.firstTeacher = listData[i].speakerName;
                                            this.firstTime = listData[i].liStartTime;
                                            this.firstState = listData[i].liState;
                                            this.firstLogo = listData[i].liLogo;
                                            this.firstId = listData[i].liId
                                            listData.splice(i,1);
                                        }else{
                                            this.firstData = false;
                                        }
                                    }
                                };
                                this.list = this.list.concat(listData);
                                if( realLength != 10){
                                    this.isload = true;
                                }
                            }else{
                                this.isNone = true;
                            }
                            
                            
                        }
                    }).catch(err => {
                        
                    });
            },
             // 移入
            overActive(index) {
                this.isBackSee = this.list[index].liId;
                this.mouseOverActive = this.list[index].liId;
            },
            // 移出
            leaveAction() {
                this.mouseOverActive = "";
                this.isBackSee = false;
            }
        },
        
        mounted() {
            this.getList();
            let _this = this;
            window.onscroll = function(){
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
                //滚动条到底部的条件
                if(scrollTop+windowHeight == scrollHeight){
                //到了这个就可以进行业务逻辑加载后台数据了
                    if( !_this.isload ){
                        if( _this.$route.path == "/Livelist" ){
                            _this.page++;
                            _this.getList();
                            console.log("到了底部");
                        }
                        
                    }
                    
                } 
            };
            
        },
        
        created(){
            
        },
        update(){
           
        },
        beforeDestroy(){
            
        },
        destroyed(){
            

        },
    }
</script>
<style scoped>
    .list-item{
        width: 100%;
        text-align: center;
        height: 30px;
        background: pink;
        margin-bottom: 1px;
        line-height: 30px;
    }
    .livingWrap{
        width: 1200px;
        height: 532px;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); 
        margin-top: 20px;
        padding:30px 24px;
    }
    .titleImg{
        display: block;
        width: 200px;
    }
    .livingInfo{
        width: 100%;
        height: 410px;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        
    }
    .livingImg{
        width: 760px;
    }
    .livingImg img{
        width: 100%;
        height: 100%;
    }
    .livingText{
        width: 392px;
        padding:0 30px;
        position: relative;
    }
    .livingName{
        font-size: 24px;
        color: #4B9AFB;
        font-weight: normal;
        line-height: 38px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        margin: 25px 0;
        padding: 0;
    }
    .livingState img{
        display: inline-block;
        width: 24px;
    }
    .livingState span{
        display: inline-block;
        color: #24B291;
        vertical-align: top;
        margin-left: 8px;
    }
    .livingTeacher{
        margin-top: 24px;
    }
    .livingTeacher li{
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        color: #999999;
        margin-bottom: 10px;
    }
    .toWatch{
        width: 340px;
        height: 56px;
        position: absolute;
        left: 50%;
        bottom: 35px;
        background: linear-gradient(168deg,#4b9afb 0%, #a1ccff 100%);
        border-radius: 8px;
        color: #fff;
        text-align: center;
        line-height: 56px;
        margin-left: -170px;
    }
    .videoWrap{
        background: #fff;
        border-radius: 8px;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10); 
        margin-top: 24px;
    }
    .totalVideo{
        background: #fff;
        height: 120px;
        border-radius: 8px 8px 0px 0px;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.10); 
        margin: 0;
        position: relative;
        z-index: 20;
    }
    .totalVideo img{
        display: inline-block;
        width: 150px;
        margin-left: 23px;
        margin-top: 40px;
    }
    .videoList{
        /* padding: 0px 24px; */
        z-index: 0;
        /* background: #DDDDDD; */
    }
    .videoItem{
        /* width: 100%; */
        height: 180px;
        background-color: #fff;
        border-bottom: 1px solid #DDDDDD;
        padding: 22px 0 0 0;
        position: relative;
        padding: 0px 24px;
        
        margin-bottom: 1px;
        z-index: 0;
    }
    .videoItem:hover{
        position: relative;
        /* box-shadow: 0px 5px 10px 0px rgba(75,155,251,0.10); */
        box-shadow: 0px 1px 20px 0px rgba(0,0,0,0.20); 
        z-index: 10;
        border-bottom:none;
    }
    .videoPostImg{
        float: left;
        width: 246px;
        height: 132px;
        border-radius: 8px;
        overflow: hidden;
        margin-top: 24px;
        position: relative;
    }
    .videoPostImg img{
        width: 100%;
        height: 100%;
    }
    .stateWrap{
        width: 100%;
        height: 100%;
        position: absolute;
    }
    .videoInfo{
        float: left;
        padding-left:24px;
        margin-top: 20px;
    }
    .videoName{
        margin-top: 24px;
        height: 20px;
    }
    .videoName img{
        float: left;
    }
    .videoTitleName{
        float: left;
        font-size: 18px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        color: #333333;
        margin-top: -3px;
        margin-left: 9px;
    }
    .videoTeacher{
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        color: #999999;
        line-height: 18px;
        margin-top: 15px;
    }
    .videoTime{
       margin-top: 20px;
    }
    .videoState{
        height: 15px;
    }
    .videoState em{
        float: left;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-style: Normal;
        margin-top: -2px;
        margin-left: 8px;
    }
    .videoState span{
        float: left;
        width: 16px;
    }
    .livingTime{
        float: left;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-style: Normal;
        color: #999999;
        margin-left: 20px;
        margin-top: -2px;
    }
    .toPlay{
        display: block;
        position: absolute;
        right: 24px;
        top: 63px;
        width: 142px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        color: #4B9AFB;
        background: #e4f0fe;
        border-radius: 8px;
        cursor: pointer;
    }
    .videoMask{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.6;
        border-radius: 8px;
        background: #000;
    }
    .hoverState{
        position: absolute;
        left: 0;
        width: 100%;
        text-align: center;
        /* top: 54px; */
        line-height: 132px;
    }
    .hoverState em{
        display: inline-block;
        width: 24px;
        /* margin-top: 5px; */
    }
    .hoverState span{
        color: #fff;
        vertical-align: top;
    }
    .mouseOverClass{
        color: #4B9AFB;
    }
    .btnActive{
        background: #4b9afb;
        color: #fff;
    }
    .dixian{
        text-align: center;
        height: 50px;
        line-height: 50px;
        color: #999999;
    }
    .toDetail{
        display: block;
        width: 100%;
        height: 100%;
    }
    .o-color{
        color:#F48549;
    }
    .g-color{
        color: #24B291;
    }
    .h-color{
        color: #999999;
    }
    .w-color{
        color: #fff;
    }
    .emptyList{
        width: 100%;
        text-align: center;
        padding-top: 100px;
    }
</style>



// WEBPACK FOOTER //
// src/views/Livelist/Livelist.vue